var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19.03 17.97a.75.75 0 1 0-1.06 1.06l1.06-1.06Zm2.44 4.56a.75.75 0 1 0 1.06-1.06l-1.06 1.06Zm.28-11.03c0-5.66-4.59-10.25-10.25-10.25v1.5a8.75 8.75 0 0 1 8.75 8.75h1.5ZM11.5 1.25C5.84 1.25 1.25 5.84 1.25 11.5h1.5a8.75 8.75 0 0 1 8.75-8.75v-1.5ZM1.25 11.5c0 5.66 4.59 10.25 10.25 10.25v-1.5a8.75 8.75 0 0 1-8.75-8.75h-1.5ZM11.5 21.75c5.66 0 10.25-4.59 10.25-10.25h-1.5a8.75 8.75 0 0 1-8.75 8.75v1.5Zm6.47-2.72 3.5 3.5 1.06-1.06-3.5-3.5-1.06 1.06Z",
  fill: "#9A9A9A"
})));
export default SvgSearch;